export const allowedSpecialChars = '^$*.[]{}()?-"!@#%&/\\,><\':;|_~`+=';

export const passwordPolicyMessage =
    'A password deve ter pelo menos uma letra maiúscula, uma minúscula, um número e um caracter especial.';

export const hasRequiredSpecialChar = (value) => {
    if (typeof value !== 'string' || value.length === 0) {
        return false;
    }

    return value.split('').some((char, index) => {
        if (char === ' ') {
            return index > 0 && index < value.length - 1;
        }

        return allowedSpecialChars.includes(char);
    });
};

export const validatePasswordPolicy = (value) => {
    if (typeof value !== 'string' || value.length === 0) {
        return false;
    }

    return (
        /[a-z]/.test(value) &&
        /[A-Z]/.test(value) &&
        /\d/.test(value) &&
        hasRequiredSpecialChar(value)
    );
};
